const Footer = () => {
    const currentYear = new Date().getFullYear(); // Get the current year dynamically using JavaScript's Date object

    return (
        <div className="bg-indigo-300/20 h-[50px] flex items-center justify-center px-4 py-2">© {currentYear} Debt Serve. All rights reserved.</div>
    )
}

export default Footer